export default function _isPlaceholder(a) {
       return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/es/internal/_isPlaceholder.js
// module id = 178
// module chunks = 0